module.exports = __webpack_public_path__ + "img/49.fe798ea5.jpg";